// extracted by mini-css-extract-plugin
export var actions = "index-module--actions--zY-xg";
export var banner = "index-module--banner--oyq3W";
export var c = "index-module--c--p-cCq";
export var github = "index-module--github--CQZ0p";
export var start = "index-module--start--4AIxT";
export var w = "index-module--w--LIzCT";
export var w1 = "index-module--w1--ycdJC";